import { CustomError } from '@tencent/memoire-error-utils';
export var MissingIndexedDBError = CustomError.withDefaultMessage('IndexedDB is missing in global context. Consider using `indexeddbshim` for better compatibility or `fake-indexeddb` in your test environment.');
//# sourceMappingURL=error.js.map